type Handler = (...args: any[]) => void;

class EventBus {
  private events = new Map<string, Handler[]>();

  on(event: string, handler: Handler) {
    const list = this.events.get(event) || [];
    list.push(handler);
    this.events.set(event, list);
  }

  off(event: string, handler: Handler) {
    const list = this.events.get(event);
    if (list) {
      const idx = list.indexOf(handler);
      if (idx >= 0) list.splice(idx, 1);
      if (list.length === 0) this.events.delete(event);
    }
  }

  emit(event: string, ...args: any[]) {
    const list = this.events.get(event);
    if (list) {
      list.forEach((h) => h(...args));
    }
  }

  once(event: string, handler: Handler) {
    const wrapper = (...args: any[]) => {
      handler(...args);
      this.off(event, wrapper);
    };
    this.on(event, wrapper);
  }

  clear() {
    this.events.clear();
  }
}

export const eventBus = new EventBus();
